module.exports = __webpack_public_path__ + "img/27_41.78c3614c.png";